<template>
    <div id="plannerAssignLevel" class=" ">
        <div class="container admin-wrap" style="margin-top: 10px;">
            <div class="row header mb-5">
                <div class="col-lg-5 ">
                    <h3 class="text-left mb-3">
                        <!--{{$route.name}}-->
                        {{lang("Level Goal Planner")}}
                    </h3>
                </div>
                <div class="pb-5">
                    <div class="empty-list_image" v-if="ddlLevels.length<1">
                        <strong>{{lang("No Data Found")}}...</strong>
                        <img src="../assets/notfound.png"/>
                    </div>

                    <div id="level-select-table" v-if="ddlLevels.length>0">
                        <data-tables :page-size="100" v-if="!levelSelected" :data="ddlLevels">
                            <el-table-column v-for="Levels in LevelInfo"
                                             :prop="Levels.prop"
                                             :label="Levels.label"
                                             :key="Levels.prop">
                            </el-table-column>
                            <el-table-column :label="lang('Level Assign')" min-width="100px">
                                <template slot-scope="scope">
                                    <el-button type="primary"
                                               @click="levelSelect(scope.row.PK_Course_ID,scope.row.CRS_Level,scope.row.ClS_FK_Semester_ID,scope.row.academicYear )">
                                        {{lang("Assign")}}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </data-tables>

                        <div v-if="levelSelected">
                            <!-- buttons----------------------------------------------------------------------------------------------------------------------------------->
                            <K2Row space-between="true">
                                <K2Text bold="true">{{selectedAcademicYear}}</K2Text>
                                <div id="button-area" class="col-lg-24 text-right actionDiv">
                                    <el-button type="primary" @click="saveLevel()">
                                        {{lang("Save")}}
                                    </el-button>
                                    <el-button type="secondary" @click="levelUnselect()">
                                        {{lang("Level Goal Back")}}
                                    </el-button>
                                </div>
                            </K2Row>
                            <!-- tabs--------------------------------------------------------------------------------------------------------------------------------------------------------->
                            <b-tabs content-class="mt-3">
                                <!-- NEW Level Goals ------------------------------------------------------------------------------------------------------------------------------->
                                <b-tab :title='lang("Level Goals")' active>
                                    <!--<div class="col-lg-5 ">-->
                                    <!--<h4 class="text-left mb-3">{{ lang('Goal List') }} </h4>-->
                                    <!--</div>-->
                                    <div class=" formDiv">
                                        <div class="Domains" role="tablist" v-for="domain in ddlGoalsListDomain">
                                            <b-card no-body class="mb-2 border-0 border-bottom">
                                                <b-card-header header-tag="header" class="p-1 box purple border-0"
                                                               role="tab">
                                                    <K2Row space-between="true" class="p-2">
                                                        <K2Row align="center"
                                                               v-b-toggle="'my-collapse'+ddlGoalsListDomain.indexOf(domain)">
                                                            <K2Icon color="black" name="add" class="when-closed me-2"
                                                                    :font-size="uiVariable.fontSize.md"
                                                                    style="line-height: 16px"/>
                                                            <K2Icon color="black" name="remove" class="when-open me-2"
                                                                    :font-size="uiVariable.fontSize.md"
                                                                    style="line-height: 16px"/>
                                                            <a> {{ domain }}</a>
                                                        </K2Row>

                                                        <K2Row space-between="true" class="when-open"
                                                               style="width:280px">
                                                            <span style="width:70px">{{lang("Term 1")}}</span>
                                                            <span style="width:70px">{{lang("Term 2")}}</span>
                                                            <span style="width:70px">{{lang("Term 3")}}</span>
                                                            <span style="width:70px">{{lang("Term 4")}}</span>
                                                        </K2Row>

                                                    </K2Row>
                                                </b-card-header>
                                                <b-collapse v-bind:id="'my-collapse'+ddlGoalsListDomain.indexOf(domain)"
                                                            visible
                                                            accordion="my-accordion"
                                                            role="tabpanel">
                                                    <b-card-body>
                                                        <PlannerTable
                                                                v-bind:domainGoalList="ddlGoalsList.filter(n => n.PlnMasDomain === domain)"
                                                                v-bind:goalRefresh="goalRefresh"
                                                                v-bind:ddlTermGoalsLists="[ddlTerm1GoalsList,ddlTerm2GoalsList,ddlTerm3GoalsList,ddlTerm4GoalsList]"
                                                                v-bind:ddlTermClassGoalsLists="[[],[],[],[]]"


                                                                v-on:termGoalChange="termGoalChange"
                                                        />
                                                    </b-card-body>

                                                </b-collapse>

                                            </b-card>
                                        </div>
                                    </div>
                                </b-tab>
                                <!-- Custom Goals ------------------------------------------------------------------------------------------------------------------------------->
                                <b-tab :title="lang('Other Goals')">

                                    <div class="row">

                                        <div class="col-lg-12 text-left">
                                            <el-button type="primary" class="mt-2 mb-2" @click="AddCustomGoals()">
                                                {{lang("Add Custom Goals")}}
                                            </el-button>
                                        </div>

                                        <div v-if="ddlCustomGoalList.length">
                                            <div class=" formDiv">
                                                <div class="Domains" role="tablist"
                                                     v-for="domain in ddlCustomGoalDomainList">
                                                    <b-card no-body class="mb-2 border-0 border-bottom">
                                                        <b-card-header header-tag="header"
                                                                       class="p-1 box purple border-0" role="tab">
                                                            <K2Row space-between="true" class="p-2">
                                                                <K2Row align="center"
                                                                       v-b-toggle="'my-collapse'+ddlCustomGoalDomainList.indexOf(domain)">
                                                                    <K2Icon color="black" name="add"
                                                                            class="when-open me-2"
                                                                            :font-size="uiVariable.fontSize.md"
                                                                            style="line-height: 16px"/>
                                                                    <K2Icon color="black" name="remove"
                                                                            class="when-closed me-2"
                                                                            :font-size="uiVariable.fontSize.md"
                                                                            style="line-height: 16px"/>
                                                                    <a> {{ domain }}</a>
                                                                </K2Row>

                                                                <K2Row space-between="true" class="when-open"
                                                                       style="width:280px">
                                                                    <span style="width:70px">{{lang("Term 1")}}</span>
                                                                    <span style="width:70px">{{lang("Term 2")}}</span>
                                                                    <span style="width:70px">{{lang("Term 3")}}</span>
                                                                    <span style="width:70px">{{lang("Term 4")}}</span>
                                                                </K2Row>

                                                            </K2Row>
                                                        </b-card-header>
                                                        <b-collapse
                                                                v-bind:id="'my-collapse'+ddlCustomGoalDomainList.indexOf(domain)"
                                                                visible accordion="my-accordion"
                                                                role="tabpanel">
                                                            <b-card-body>
                                                                <data-tables
                                                                        :data="ddlCustomGoalList.filter(n => n.PlnCusDomain === domain) ">
                                                                    <el-table-column v-for="goal in CustomGoalInfo"
                                                                                     :prop="goal.prop"
                                                                                     :label="goal.label"
                                                                                     :key="goal.prop">
                                                                    </el-table-column>

                                                                    <el-table-column id="Term1c" label="" width="70px">
                                                                        <template slot-scope="scope">
                                                                            <K2Row justify_content="center">
                                                                                <el-checkbox v-model="scope.checked"
                                                                                             @change="changeSelectionCus(scope.row.PlnCusID,1,scope.checked)"
                                                                                             :key="goalRefresh"
                                                                                             :checked="ddlTerm1CusGoalsList.indexOf(scope.row.PlnCusID) !== -1">
                                                                                </el-checkbox>
                                                                            </K2Row>
                                                                        </template>
                                                                    </el-table-column>

                                                                    <el-table-column id="Term2c" label="" width="70px">
                                                                        <template slot-scope="scope">
                                                                            <K2Row justify_content="center">
                                                                                <el-checkbox v-model="scope.checked"
                                                                                             @change="changeSelectionCus(scope.row.PlnCusID,2,scope.checked )"
                                                                                             :key="goalRefresh"
                                                                                             :checked="ddlTerm2CusGoalsList.indexOf(scope.row.PlnCusID) !== -1"></el-checkbox>
                                                                            </K2Row>
                                                                        </template>
                                                                    </el-table-column>

                                                                    <el-table-column id="Term3c" label="" width="70px">
                                                                        <template slot-scope="scope"
                                                                                  class="text-center">
                                                                            <K2Row justify_content="center">
                                                                                <el-checkbox v-model="scope.checked"
                                                                                             @change="changeSelectionCus(scope.row.PlnCusID,3,scope.checked)"
                                                                                             :key="goalRefresh"
                                                                                             :checked="ddlTerm3CusGoalsList.indexOf(scope.row.PlnCusID) !== -1">
                                                                                </el-checkbox>
                                                                            </K2Row>
                                                                        </template>
                                                                    </el-table-column>

                                                                    <el-table-column id="Term4c" label="" width="70px">
                                                                        <template slot-scope="scope"
                                                                                  class="text-center">
                                                                            <K2Row justify_content="center">
                                                                                <el-checkbox v-model="scope.checked"
                                                                                             @change="changeSelectionCus(scope.row.PlnCusID,3,scope.checked)"
                                                                                             :key="goalRefresh"
                                                                                             :checked="ddlTerm4CusGoalsList.indexOf(scope.row.PlnCusID) !== -1">
                                                                                </el-checkbox>
                                                                            </K2Row>
                                                                        </template>
                                                                    </el-table-column>

                                                                </data-tables>
                                                            </b-card-body>
                                                        </b-collapse>
                                                    </b-card>
                                                </div>


                                            </div>

                                        </div>

                                        <div class="empty-list_image" v-else>
                                            <strong>{{lang("No Custom Goals")}}...</strong>
                                            <img src="../assets/notfound.png"/>
                                        </div>

                                    </div>
                                </b-tab>

                            </b-tabs>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Pop Up---------------------------------------------------------------------------------------------------------------------------------------------------->
        <b-modal id="assignedPlannerModel" size="lg" title="Custom Goals" ok-only ok-variant="secondary"
                 ok-title="Cancel" ref="assignedPlannerShowModel" hide-footer>
            <div class="row">
                <div class="row">
                    <label>{{lang("Domain")}}</label>
                    <el-select v-model="selectedCustomDomain"
                               :placeholder="lang('Select Domain')"
                               class="pro-edt-select"
                               style="margin-right: 10px;"
                               id="selectedCustomDomain"
                               @change="generateGoalSelectionList()">
                        <el-option
                                v-for="item in ddlGoalsListDomain"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                    </el-select>
                </div>
                <div class="row">
                    <label>{{lang("Goals")}}</label>
                    <el-select v-model="selectedCustomGoal"
                               :placeholder="lang('Select Goal')"
                               class="pro-edt-select"
                               style="margin-right: 10px;"
                               id="ddlClassID"
                               @change="fetchCustomGoals()">
                        <el-option
                                v-for="item in customGoalSelectionList"
                                :key="item.goal"
                                :label="item.goal"
                                :value="item.goal">
                        </el-option>
                    </el-select>
                    <div class="col-lg-12 divKeyInKeySkillorCld">
                        <label>{{lang("Learning Goals")}}</label>
                        <input type="text" class="form-control inputKeySkillCLD" v-model="customGoalIndicator"
                               :placeholder="lang('Enter Indicator')">
                    </div>
                    <div class="col-lg-12"
                         v-if="selectedCustomDomain !== '' && selectedCustomGoal !== '' && customGoalIndicator !== ''">
                        <el-button type="primary" class="mt-2 mb-2" @click="insertCustomGoal()">
                            {{lang("Add")}}
                        </el-button>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div v-if="fetchedCustomGoalList.length>0">
                        <data-tables :data="fetchedCustomGoalList ">
                            <el-table-column v-for="goal in CustomGoalInfo"
                                             :prop="goal.prop"
                                             :label="goal.label"
                                             :key="goal.key">
                            </el-table-column>
                            <el-table-column label="Assign" min-width="100px">
                                <template slot-scope="scope">
                                    <el-button type="primary" @click="assignCustomGoal(scope.row)">
                                        <!--                    levelSelect(scope.row.PK_Course_ID,scope.row.CRS_Level,scope.row.ClS_FK_Semester_ID-->
                                        {{lang("Assign")}}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </data-tables>
                    </div>

                    <div class="empty-list_image" v-else>
                        <strong>{{lang("No Data Found")}}...</strong>
                        <img src="../assets/notfound.png"/>
                    </div>

                </div>
            </div>
        </b-modal>
    </div>


</template>

<script>
  import DataSource from "../data/datasource";
  import { lang, selectedLocale } from "../locale/index";
  import Vue from "vue";
  import VueTour from "vue-tour";
  import K2Row from "../uiComponents/k2Row/k2Row";
  import K2Icon from "../uiComponents/k2Icon/k2MAIcon";
  import uiVariable from "../config/uiVariable";
  import Cookies from "js-cookie";
  import K2ToolTip from "@/uiComponents/k2ToolTip/k2ToolTip";
  import PlannerTable from "@/uiComponents/K2PlannerTable/PlannerTable";
  import K2Text from "../uiComponents/k2Text/k2Text";

  export default {
    name: "PlannerAssignLevel",
    components: { K2Text, K2ToolTip, K2Icon, K2Row, PlannerTable },

    data() {
      return {
        uiVariable: uiVariable,

        ddlLevels: [],
        ddlGoalsList: [],
        ddlGoalsListDomain: [],

        ddlSemesterDetailsList: [],
        TermSemdID: [],
        ddlTerm1GoalsList: [],
        ddlTerm2GoalsList: [],
        ddlTerm3GoalsList: [],
        ddlTerm4GoalsList: [],

        schID: "",
        crsID: "",
        level: "",
        semID: "",
        selectedAcademicYear:"",
        LevelInfo: [
          {
            prop: "academicYear",
            label: lang("Academic Year")
          },
          {
            prop: "CRS_Course_Name",
            label: lang("Course Name")
          }, {
            // prop: "CRS_Course_Type",
            // label: "Course Type"
            // }, {
            prop: "GoalCount",
            label: lang("No of assigned Goals")
          }],
        goalsListInfo: [{
          //   prop: "PlnMasDomain",
          //   label: "Domain"
          // }, {
          //   prop: "PlnMasGoalsITL",
          //   label: "Goals"
          // }, {
          prop: "PlnMasIndicator",
          label: lang("Indicator")
          // }, {
          //   prop: "PlnMasIndicatorType",
          //   label: "Indicator Type"
        }],
        CustomGoalInfo: [{
          //   prop: "PlnCusDomain",
          //   label: "Domain"
          // }, {
          //   prop: "PlnCusGoalsITL",
          //   label: "Goal"
          // }, {
          prop: "PlnCusIndicator",
          label: lang("Indicator")
        }],

        levelSelected: false,
        goalRefresh: 0,

        selectedCustomDomain: "",
        selectedCustomGoal: "",
        customGoalIndicator: "",
        customGoalSelectionList: [],
        GoalDomainSelectionList: [],

        fetchedCustomGoalList: [],
        ddlCustomGoalDomainList: [],
        ddlCustomGoalList: [],


        ddlTerm1CusGoalsList: [],
        ddlTerm2CusGoalsList: [],
        ddlTerm3CusGoalsList: [],
        ddlTerm4CusGoalsList: []
      };
    },


    async created() {
      this.schID = Cookies.get("schoolSession");
      await this.bindLevels();

    },
    methods: {
      lang,

      async bindLevels() {
        try {
          const academicYearList = await this.getAcademicYear();

          const response = await DataSource.shared.getLevelList(this.schID);
          response.Table.forEach(d => {

            let academicYear = academicYearList.find(a => a.PK_Semester_ID === d.ClS_FK_Semester_ID);

            d.academicYear = academicYear.SMT_Code;
          });

          this.ddlLevels = response.Table;
        } catch (e) {
          this.results = e;
        }
      },
      async getAcademicYear() {
        try {
          const response = await DataSource.shared.getAcademicYear("");
          if (response) {
            if (response.code === "88") {
              window.location.replace("/");
            } else {
              return response.Table;
            }
          }
        } catch (e) {
          this.results = e;
        }
      },
      async levelSelect(crsID, level, semID, academicYear) {
        this.$vs.loading();

        this.crsID = crsID;
        this.level = level;
        this.semID = semID;
        this.selectedAcademicYear = academicYear;
        this.levelSelected = true;

        this.resetAll();
        this.ddlGoalsList = await this.getPlannerMaster(this.level);
        await this.bindSemesterDetails();
        this.ddlGoalsList.forEach(n => {
          const pos = this.ddlGoalsListDomain.indexOf(n.PlnMasDomain);
          if (pos === -1) {
            this.ddlGoalsListDomain.push(n.PlnMasDomain);
          }
        });

        this.ddlTerm1GoalsList = await this.getLevelGoals(this.TermSemdID[0]);
        this.ddlTerm2GoalsList = await this.getLevelGoals(this.TermSemdID[1]);
        this.ddlTerm3GoalsList = await this.getLevelGoals(this.TermSemdID[2]);
        this.ddlTerm4GoalsList = await this.getLevelGoals(this.TermSemdID[3]);

        this.ddlTerm1CusGoalsList = await this.getLevelCustomGoals(this.TermSemdID[0]);
        this.ddlTerm2CusGoalsList = await this.getLevelCustomGoals(this.TermSemdID[1]);
        this.ddlTerm3CusGoalsList = await this.getLevelCustomGoals(this.TermSemdID[2]);
        this.ddlTerm4CusGoalsList = await this.getLevelCustomGoals(this.TermSemdID[3]);

        this.ddlCustomGoalList = await this.getSaveCustomGoalList();
        this.generateCustomDomainList(this.ddlCustomGoalList);

        this.goalRefresh++;
        this.$vs.loading.close();

      },

      async bindSemesterDetails() {
        try {

          this.ddlSemesterDetailsList = [];
          let result = [];

          const response = await DataSource.shared.getSemesterTermDetailsBySemID(this.semID, "", "Active");
          if (response) {
            result = response.Table;
            result.forEach(m => {
              this.ddlSemesterDetailsList.push(m);
            });
          }
        } catch (e) {
          this.results = e;
        }

        let Term1SemdID = "";
        let Term2SemdID = "";
        let Term3SemdID = "";
        let Term4SemdID = "";

        this.ddlSemesterDetailsList.forEach(semester => {
          switch (semester.SEMD_DetailName) {
            case "Term 1":
              Term1SemdID = semester.PK_SEMD_ID;
              this.currentSemID = semester.PK_Semester_ID;
              break;
            case "Term 2":
              Term2SemdID = semester.PK_SEMD_ID;
              break;
            case "Term 3":
              Term3SemdID = semester.PK_SEMD_ID;
              break;
            case "Term 4":
              Term4SemdID = semester.PK_SEMD_ID;
              break;
          }
        });
        this.TermSemdID.push(Term1SemdID);
        this.TermSemdID.push(Term2SemdID);
        this.TermSemdID.push(Term3SemdID);
        this.TermSemdID.push(Term4SemdID);

      },

      async levelUnselect() {
        this.crsID = "";
        this.levelSelected = false;
      },

      async saveLevel() {
        let newPlannerAssignedToSchoolObjJson = {
          CrsID: this.crsID,
          semID: this.semID,
          Term1SemdID: this.TermSemdID[0],
          Term2SemdID: this.TermSemdID[1],
          Term3SemdID: this.TermSemdID[2],
          Term4SemdID: this.TermSemdID[3],
          Term1GoalsList: this.ddlTerm1GoalsList,
          Term2GoalsList: this.ddlTerm2GoalsList,
          Term3GoalsList: this.ddlTerm3GoalsList,
          Term4GoalsList: this.ddlTerm4GoalsList

        };

        const response = await DataSource.shared.savePlannerAssignedToCourse(JSON.stringify(newPlannerAssignedToSchoolObjJson));
        await this.saveCusLevel();
        if (response.code === "2") {
          this.$notify.error({
            title: "Error",
            message: "Please select Class & Term..."
          });
        } else if (response.code === "88") {
          window.location.replace("/");
        } else if (response.code === "99") {
          this.$notify.error({
            title: "Error",
            message: "Class Goals Details: ERROR!!"
          });
        } else {
          this.$notify.info({
            title: "Successfully",
            message: "Successfully Save..."
          });
        }
        // console.log(response);
      },

      async getPlannerMaster(LevelType) {

        try {
          let result = [];
          let IB = "NON IB";

          if (Cookies.get("schoolSession") === "SCH201400000553" || Cookies.get("schoolSession") === "SCH201400000471") {

            if (LevelType === "N2" || LevelType === "K1" || LevelType === "K2") {
              IB = "IB";
            } else if (selectedLocale() === "CH") {
              IB = "IB";
            }
          }

          const response = await DataSource.shared.getPlannerMaster(LevelType, "", "", "", IB);
          if (response) {
            if (response.code === "88") {
              window.location.replace("/");
            } else if (response.code === "99") {
              console.log("getPlannerMaster error");
            } else if (response.code === "2") {
              console.log("getPlannerMaster no record");
            } else {
              result = response.Table;
              console.log(result.length);
            }
          }

          return result;
        } catch (e) {
          this.results = e;
        }

      },

      async getLevelGoals(semID) {
        try {
          let result = [];

          const response = await DataSource.shared.getPlannerAssignedToLevel(this.crsID, semID);
          if (response) {
            if (response.code === "2") {
              console.log("getPlannerAssignedStudentDetails no record");
            } else if (response.code === "88") {
              window.location.replace("/");
            } else if (response.code === "99") {
              console.log("getPlannerAssignedStudentDetails error");
            } else {
              response.Table.forEach(m => {
                let temp = m.PlnCxPlnMasID;
                result.push(temp);
              });
            }
          }
          return result;
        } catch (e) {
          this.results = e;
        }
      },

      changeSelection(Goal, Term, Check) {
        switch (Term) {
          case 1 :
            if (Check) {
              if (this.ddlTerm1GoalsList.indexOf(Goal) === -1) {
                this.ddlTerm1GoalsList.push(Goal);
              }
            } else {
              this.ddlTerm1GoalsList = this.ddlTerm1GoalsList.filter(function(goal) {
                return goal !== Goal;
              });
            }
            break;
          case 2 :
            if (Check) {
              if (this.ddlTerm2GoalsList.indexOf(Goal) === -1) {
                this.ddlTerm2GoalsList.push(Goal);
              }
            } else {
              this.ddlTerm2GoalsList = this.ddlTerm2GoalsList.filter(function(goal) {
                return goal !== Goal;
              });
            }
            break;
          case 3:
            if (Check) {
              if (this.ddlTerm3GoalsList.indexOf(Goal) === -1) {
                this.ddlTerm3GoalsList.push(Goal);
              }
            } else {
              this.ddlTerm3GoalsList = this.ddlTerm3GoalsList.filter(function(goal) {
                return goal !== Goal;
              });
            }
            break;
          case 4 :
            if (Check) {
              if (this.ddlTerm4GoalsList.indexOf(Goal) === -1) {
                this.ddlTerm4GoalsList.push(Goal);
              }
            } else {
              this.ddlTerm4GoalsList = this.ddlTerm4GoalsList.filter(function(goal) {
                return goal !== Goal;
              });
            }
            break;
        }
      },

      //---------------------------------------------------------------------------------------------------------------------

      async AddCustomGoals() {
        const response = await DataSource.shared.getDomainList(this.currentClsID);
        this.GoalDomainSelectionList = response.Table;
        this.$refs.assignedPlannerShowModel.show();
      },

      async generateGoalSelectionList() {

        let customgoalgoallist = this.ddlGoalsList.filter(n => n.PlnMasDomain === this.selectedCustomDomain);
        this.customGoalSelectionList = [];
        // item.PlnMasGoalsITL
        let temp = [];
        let list = [];
        customgoalgoallist.forEach(
          m => {
            if (temp.indexOf(m.PlnMasGoalsITL) < 0) {
              temp.push(m.PlnMasGoalsITL);
              list.push({ "goal": m.PlnMasGoalsITL });
            }
          }
        );
        this.customGoalSelectionList = list;


      },

      async fetchCustomGoals() {

        try {

          this.fetchedCustomGoalList = [];

          const response = await DataSource.shared.fetchCustomGoals(this.selectedCustomDomain, this.selectedCustomGoal);
          if (response.code === "3" || response.code === "99") {

          } else {

            this.fetchedCustomGoalList = response.Table;

          }


        } catch (e) {
          this.results = e;
        }

      },

      async insertCustomGoal() {

        await DataSource.shared.insertCustomGoal(this.selectedCustomDomain, this.selectedCustomGoal, this.customGoalIndicator);
        await this.fetchCustomGoals();
        this.customGoalIndicator = "";
        // console.log()
      },

      assignCustomGoal(goal) {
        let existInDB = false;
        this.ddlCustomGoalList.forEach(m => {
          if (m.PlnCusID === goal.PlnCusID) {
            existInDB = true;
          }

        });

        if (!existInDB) {
          this.ddlCustomGoalList.push(goal);
        } else {
          this.$notify.error({
            title: "Alert",
            message: "The goal already exist in the list"
          });
        }
        if (this.ddlCustomGoalDomainList.indexOf(goal.PlnCusDomain) < 0) {
          this.ddlCustomGoalDomainList.push(goal.PlnCusDomain);
        }

      },

      generateCustomDomainList(goalList) {
        goalList.forEach(goal => {
          if (this.ddlCustomGoalDomainList.indexOf(goal.PlnCusDomain) < 0) {
            this.ddlCustomGoalDomainList.push(goal.PlnCusDomain);
          }
        });


      },

      changeSelectionCus(Goal, Term, Check) {
        switch (Term) {
          case 1 :
            if (Check) {
              if (this.ddlTerm1CusGoalsList.indexOf(Goal) === -1) {
                this.ddlTerm1CusGoalsList.push(Goal);
              }
            } else {
              this.ddlTerm1CusGoalsList = this.ddlTerm1CusGoalsList.filter(function(goal) {
                return goal !== Goal;
              });
            }
            break;
          case 2 :
            if (Check) {
              if (this.ddlTerm2CusGoalsList.indexOf(Goal) === -1) {
                this.ddlTerm2CusGoalsList.push(Goal);
              }
            } else {
              this.ddlTerm2CusGoalsList = this.ddlTerm2CusGoalsList.filter(function(goal) {
                return goal !== Goal;
              });
            }
            break;
          case 3:
            if (Check) {
              if (this.ddlTerm3CusGoalsList.indexOf(Goal) === -1) {
                this.ddlTerm3CusGoalsList.push(Goal);
              }
            } else {
              this.ddlTerm3CusGoalsList = this.ddlTerm3CusGoalsList.filter(function(goal) {
                return goal !== Goal;
              });
            }
            break;
          case 4 :
            if (Check) {
              if (this.ddlTerm4CusGoalsList.indexOf(Goal) === -1) {
                this.ddlTerm4CusGoalsList.push(Goal);
              }
            } else {
              this.ddlTerm4CusGoalsList = this.ddlTerm4CusGoalsList.filter(function(goal) {
                return goal !== Goal;
              });
            }
            break;

        }
      },

      async saveCusLevel() {
        let newPlannerAssignedToSchoolObjJson = {
          CrsID: this.crsID,
          semID: this.semID,
          Term1SemdID: this.TermSemdID[0],
          Term2SemdID: this.TermSemdID[1],
          Term3SemdID: this.TermSemdID[2],
          Term4SemdID: this.TermSemdID[3],
          Term1GoalsList: this.ddlTerm1CusGoalsList,
          Term2GoalsList: this.ddlTerm2CusGoalsList,
          Term3GoalsList: this.ddlTerm3CusGoalsList,
          Term4GoalsList: this.ddlTerm4CusGoalsList

        };

        const response = await DataSource.shared.saveCustomPlannerAssignedToCourse(JSON.stringify(newPlannerAssignedToSchoolObjJson));
        if (response.code === "2") {
          this.$notify.error({
            title: "Error",
            message: "Please select Class & Term..."
          });
        } else if (response.code === "88") {
          window.location.replace("/");
        } else if (response.code === "99") {
          this.$notify.error({
            title: "Error",
            message: "Class Goals Details: ERROR!!"
          });
        } else {
          this.$notify.info({
            title: "Successfully",
            message: "Successfully Save..."
          });
        }
        // console.log(response);
      },

      async getLevelCustomGoals(semID) {
        try {
          let result = [];

          const response = await DataSource.shared.getCustomPlannerAssignedToLevel(this.crsID, semID);
          if (response) {
            if (response.code === "2") {
              console.log("getPlannerAssignedStudentDetails no record");
            } else if (response.code === "88") {
              window.location.replace("/");
            } else if (response.code === "99") {
              console.log("getPlannerAssignedStudentDetails error");
            } else {
              response.Table.forEach(m => {
                let temp = m.PlnCuxPlnCusID;
                result.push(temp);
              });
            }
          }
          return result;
        } catch (e) {
          this.results = e;
        }

      },

      async getSaveCustomGoalList() {
        try {
          const response = await DataSource.shared.getSaveCustomGoalList(
            JSON.stringify(this.ddlTerm1CusGoalsList),
            JSON.stringify(this.ddlTerm2CusGoalsList),
            JSON.stringify(this.ddlTerm3CusGoalsList),
            JSON.stringify(this.ddlTerm4CusGoalsList)
          );
          let result = [];
          result = response.Table;
          return result;
        } catch (e) {
          return [];
        }


      },

      resetAll() {
        this.ddlGoalsList = [];
        this.ddlGoalsListDomain = [];
        this.ddlTerm1LevelGoalsList = [];
        this.ddlTerm2LevelGoalsList = [];
        this.ddlTerm3LevelGoalsList = [];
        this.ddlTerm4LevelGoalsList = [];

        this.ddlTerm1ClassGoalsList = [];
        this.ddlTerm2ClassGoalsList = [];
        this.ddlTerm3ClassGoalsList = [];
        this.ddlTerm4ClassGoalsList = [];


        this.ddlTerm1CombinedGoalsList = [];
        this.ddlTerm2CombinedGoalsList = [];
        this.ddlTerm3CombinedGoalsList = [];
        this.ddlTerm4CombinedGoalsList = [];

        this.ddlTerm1CusGoalsList = [];
        this.ddlTerm2CusGoalsList = [];
        this.ddlTerm3CusGoalsList = [];
        this.ddlTerm4CusGoalsList = [];
        this.ddlCustomGoalList = [];
      },

      termGoalChange(value) {

        this.changeSelection(value[0], value[1], value[2]);

      }

    }


  };

</script>

<style scoped>
    .sc-table {
        margin-top: 0px;
    }

    .sc-table .el-table__header-wrapper {
        display: none !important;
    }


</style>